import Select from "react-select";
import {useQuery} from "react-query";
import React, {useEffect, useState} from "react";
import {getPaymentTypes} from "Api/Query/PaymentTypeQuery";
import {SelectOptionType} from "Model/Select/SelectOption";

interface Props {
    onChange: (newValue: SelectOptionType|null) => void,
    value?: any,
    classes?: string,
    placeholder?: string,
    defaultPaymentTypeId?: string
}

export const PaymentTypeSelect : React.FC<Props> = (props) => {

    const [options, setOptions] = useState<SelectOptionType[]>([])
    const [value, setValue] = useState<SelectOptionType|null>(null)

    const paymentTypesQuery = useQuery({
        enabled: false,
        queryKey: ['getPaymentTypes'],
        queryFn: () => getPaymentTypes(),
        onSuccess: (response: any) => {
            const paymentTypes : SelectOptionType[] = []
            response.data._result.items.map((item: any) => {
                if (!item.enabled) return

                paymentTypes.push({
                    label: item.name,
                    value: item.id
                })

                if(props.defaultPaymentTypeId && item.id === props.defaultPaymentTypeId) {
                    const defaultValue = {
                        label: item.name,
                        value: item.id
                    }
                    setValue(defaultValue)
                    props.onChange(defaultValue)
                }
            })
            setOptions(paymentTypes)
        }
    })

    useEffect(() => {
        paymentTypesQuery.refetch()
    }, [])

    return (
        <Select
            isLoading={paymentTypesQuery.isRefetching || paymentTypesQuery.isLoading}
            options={options}
            placeholder={props.placeholder ?? ""}
            noOptionsMessage={() => "No hay resultados"}
            isClearable={true}
            loadingMessage={() => "Cargando ..."}
            onChange={(newValue: any) => {
                setValue(newValue)
                props.onChange(newValue)
            }}
            className={props.classes ?? ''}
            value={value}
        />
    )
}
